// Lightweight analytics wrapper over PostHog (loaded in index.html, privacy mode).
export function track(event, props = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && window.posthog.capture) {
      window.posthog.capture(event, props);
    }
  } catch (_) { /* no-op */ }
}
